const Certificate = () =>
  import('@/views/main/helper/certificate/CertificateManage.vue')
export default {
  path: '/main/certificate/manage',
  name: 'Certificate',
  component: Certificate,
  children: []
}
